export const BRAND_KEY = 'delonghi'
export const BRAND_LABEL = 'DeLonghi'
export const BRAND_SHORT_LABEL = 'DL'
export const BRAND_CODE_MARKETING_CLOUD = 'dln'
export const BRAND_INFO = {
    key: BRAND_KEY,
    label: BRAND_LABEL,
    short_label: BRAND_SHORT_LABEL,
}
